export default function GrainOverlay() {
  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] opacity-[0.025]">
      <svg className="w-full h-full" aria-hidden="true">
        <defs>
          <filter id="grain-noise">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.8"
              numOctaves="4"
              stitchTiles="stitch"
            />
          </filter>
        </defs>
        <rect width="100%" height="100%" filter="url(#grain-noise)" />
      </svg>
    </div>
  );
}
